import { VideoIcon } from "components/icons/video-icon";
import React from "react";
import { VideoChipContainer } from "./video-chip.styles";
import { IVideoChipProps } from "./video-chip.types";

const VideoChip: React.FC<IVideoChipProps> = ({ value }) => (
  <VideoChipContainer>
    <VideoIcon width={20} height={15} /> {value} Video
  </VideoChipContainer>
);

export { VideoChip };
